/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PaymentMethodsCard,
  PaymentMethodsCard$inboundSchema,
  PaymentMethodsCard$Outbound,
  PaymentMethodsCard$outboundSchema,
} from "./paymentmethodscard.js";

export type PullFromCardPaymentMethod = {
  /**
   * ID of the payment method.
   */
  paymentMethodID: string;
  paymentMethodType: "pull-from-card";
  /**
   * A card as contained within a payment method.
   */
  card: PaymentMethodsCard;
};

/** @internal */
export const PullFromCardPaymentMethod$inboundSchema: z.ZodType<
  PullFromCardPaymentMethod,
  z.ZodTypeDef,
  unknown
> = z.object({
  paymentMethodID: z.string(),
  paymentMethodType: z.literal("pull-from-card"),
  card: PaymentMethodsCard$inboundSchema,
});
/** @internal */
export type PullFromCardPaymentMethod$Outbound = {
  paymentMethodID: string;
  paymentMethodType: "pull-from-card";
  card: PaymentMethodsCard$Outbound;
};

/** @internal */
export const PullFromCardPaymentMethod$outboundSchema: z.ZodType<
  PullFromCardPaymentMethod$Outbound,
  z.ZodTypeDef,
  PullFromCardPaymentMethod
> = z.object({
  paymentMethodID: z.string(),
  paymentMethodType: z.literal("pull-from-card"),
  card: PaymentMethodsCard$outboundSchema,
});

export function pullFromCardPaymentMethodToJSON(
  pullFromCardPaymentMethod: PullFromCardPaymentMethod,
): string {
  return JSON.stringify(
    PullFromCardPaymentMethod$outboundSchema.parse(pullFromCardPaymentMethod),
  );
}
export function pullFromCardPaymentMethodFromJSON(
  jsonString: string,
): SafeParseResult<PullFromCardPaymentMethod, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PullFromCardPaymentMethod$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PullFromCardPaymentMethod' from JSON`,
  );
}
